import axios from 'axios';

/**
 * Instance axios dédiée à l'espace professionnel — utilise un token JWT
 * distinct (representant_token) de celui des agents judiciaires.
 */
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3030/api';

export const REPRESENTANT_TOKEN_KEY = 'representant_token';
export const REPRESENTANT_DATA_KEY = 'representant_data';

const representantApi = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

representantApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(REPRESENTANT_TOKEN_KEY);
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

representantApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(REPRESENTANT_TOKEN_KEY);
      localStorage.removeItem(REPRESENTANT_DATA_KEY);
    }
    return Promise.reject(error);
  },
);

export default representantApi;
